import React from 'react'

import { QueryConfig } from 'metrics-chart'

import { getGrafanaLink } from '~/pages/reports/comparison/Report/customColumns'
import { OrgType } from '~/pages/reports/comparison/shared/context'

import { PromQLDashboard, ReportArgs } from '../../shared/types'

export interface MetricDashboard extends QueryConfig {
  dashboard: PromQLDashboard[]
}

export const GrafanaLink: React.FC<{
  dashboards: MetricDashboard[]
  orgId: string
  orgType: OrgType
  clusterId: string
  reportArgs?: ReportArgs
}> = ({ dashboards, orgId, orgType, clusterId, reportArgs }) => {
  const dsMap = dashboards
    .filter((d) => !!d?.dashboard?.length)
    .reduce((prev, cur) => {
      const id = cur.dashboard[0].id
      if (!prev[id[orgType]]) {
        prev[id[orgType]] = cur
      }
      return prev
    }, {} as { [k: string]: MetricDashboard })
  const ds = Object.values(dsMap)

  if (!ds.length) {
    return null
  }

  return (
    <>
      (
      {ds.map((d, index) => {
        const dashboard = d.dashboard[0]
        const grafanaLink = getGrafanaLink(
          dashboard.id[orgType],
          orgType,
          [
            (reportArgs?.begin_ts || 0) * 1000,
            (reportArgs?.end_ts || 0) * 1000
          ],
          clusterId,
          orgId
        )

        return (
          <React.Fragment key={index}>
            <a href={grafanaLink} target='_blank'>
              {dashboard.title}
            </a>
            {index !== ds.length - 1 && ' ,'}
          </React.Fragment>
        )
      })}
      )
    </>
  )
}
